import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Bearer OTA2ZmFlM2Y3MWZiZmM1ZmRhMWEzYThmODdiNzU4ODE=',
    'Access-Control-Allow-Origin':'*',
    
  })
};

@Injectable({
  providedIn: 'root'
})
export class GenericsService {

  //private URI: string = "http://54.233.238.26:8080/projectmanager/api/v1/"; alterado para linha abaixo por marcelo huber
  //private URI: string = "http://pjmanager.com.br:8080/projectmanager/api/v1/";
  private URI: string = "http://pjmanager.com.br:8080/projectmanager/api/v1/";
  //private URI: string = ":8080/projectmanager/api/v1/";


  constructor(private http: HttpClient) { }

  getURI():string {
    return this.URI;
    //return "";
  }

  get(uri:string) {
    return this.http.get(this.getURI() + uri, httpOptions);
  }

  post(uri:string, objects?:any) {
    return this.http.post(this.getURI() + uri, objects, httpOptions);
  }
  
  put(uri:string, objects?:any) {
    return this.http.put(this.getURI() + uri, objects, httpOptions);
  }

  delete(uri:string) {
    return this.http.delete(this.getURI() + uri, httpOptions);
  }

}
